import Api from './Api'

export default {
  build (data) {
    return Api().post('/statistikk/resultatbrev/build.json', data)
  },
  getDrafts (params) {
    let query = {
      type: params.type || null,
      page: params.page || 1,
      sort: params.sort || 'id',
      direction: params.direction || 'desc',
      limit: params.limit || 500
    }

    return Api().get('/statistikk/resultatbrev/drafts.json', {
      params: query
    })
  },
  deleteDrafts (items) {
    let post = {
      queue: items
    }

    return Api().post('/statistikk/resultatbrev/drafts-delete.json', post)
  },
  approveMany (items) {
    let post = {
      queue: items
    }

    return Api().post('/statistikk/resultatbrev/approve-many.json', post)
  },
  updateManyStatus (items) {
    let post = {
      queue: items
    }

    return Api().post('/statistikk/resultatbrev/update-many-status.json', post)
  },
  loadManyForPrint (items) {
    let post = {
      queue: items
    }

    return Api().post('/statistikk/resultatbrev/load-many-print.json', post)
  },
  search (params, data) {
    let query = {
      page: params.page || 1,
      sort: params.sort || 'id',
      direction: params.direction || 'desc',
      limit: params.limit || 200
    }

    return Api().get('/statistikk/resultatbrev/search.json', {
      params: Object.assign(query, {}, data)
    })
  }
  // loadMany (manualQueueIdArray) {
  //   let post = {
  //     queue: manualQueueIdArray
  //   }

  //   return Api().post('/statistikk/resultatbrev/load-many.json', post)
  // },
  // saveMany (manualQueueIdArray, status) {
  //   let post = {
  //     queue: manualQueueIdArray,
  //     status: status
  //   }

  //   return Api().post('/statistikk/resultatbrev/unprocessed/save-many.json', post)
  // }
}



// WEBPACK FOOTER //
// ./src/services/ResultatbrevService.js